export default "__VITE_ASSET__DNIw7zJN__"